<template>
  <CommonLayout selectedNav="pdf">
    <div class="tx-wrap">
      <div class="tx-hero tx-hero-left">
        <h1 class="tx-hero-title">PDF <em>工具箱</em></h1>
        <p class="tx-hero-sub">合并 · 拆分 · 提取 · 旋转 · 压缩 · 水印 · 加解密 · 提取</p>
      </div>

      <div class="tx-grid-cards">
        <div class="tx-card" v-for="tool in tools" :key="tool.action">
          <span class="tx-corner tl"></span><span class="tx-corner tr"></span>
          <span class="tx-corner bl"></span><span class="tx-corner br"></span>

          <div class="tx-card-head">
            <i :class="tool.icon" class="tx-card-icon"></i>
            <div>
              <div class="tx-card-title">{{ tool.title }}</div>
              <div class="tx-card-desc">{{ tool.desc }}</div>
            </div>
          </div>

          <el-upload class="tx-tool-upload" :ref="'up_' + tool.action"
            :auto-upload="false" :show-file-list="true" :multiple="tool.multi"
            :limit="tool.multi ? maxUploadCount : 1" :on-change="(f, l) => onFileChange(tool.action, l)"
            :on-remove="(f, l) => onFileChange(tool.action, l)" :on-exceed="handleExceed"
            :file-list="state[tool.action].files" list-type="text">
            <el-button size="small" class="tx-mini-btn">
              <i class="el-icon-upload2"></i> {{ tool.multi ? '选择 PDF 文件' : '选择 PDF' }}
            </el-button>
          </el-upload>

          <div class="tx-params" v-if="tool.params.length">
            <div class="tx-param" v-for="p in tool.params" :key="p.key">
              <label class="tx-param-label">{{ p.label }}</label>
              <el-select v-if="p.type === 'select'" v-model="state[tool.action].params[p.key]"
                size="small" class="tx-param-input">
                <el-option v-for="o in p.options" :key="o.v" :label="o.t" :value="o.v"></el-option>
              </el-select>
              <el-input v-else v-model="state[tool.action].params[p.key]" size="small"
                class="tx-param-input" :placeholder="p.label"></el-input>
            </div>
          </div>

          <el-button type="primary" class="tx-run-btn" :loading="state[tool.action].loading"
            :disabled="state[tool.action].files.length === 0" @click="runTool(tool)">
            <i v-if="!state[tool.action].loading" class="el-icon-video-play"></i> 执行
          </el-button>

          <div class="tx-tool-result" v-if="state[tool.action].result || state[tool.action].error">
            <div class="tx-result-ok" v-if="state[tool.action].result">
              <i class="el-icon-circle-check"></i>
              <span class="tx-result-name">{{ state[tool.action].result.fileName }}</span>
              <el-link type="success" :underline="false" class="tx-dl" @click="download(tool, state[tool.action].result)">
                <i class="el-icon-download"></i> 下载
              </el-link>
              <el-link type="info" :underline="false" class="tx-del" @click="delResult(tool, state[tool.action].result)">
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
            <div class="tx-result-err" v-if="state[tool.action].error">
              <i class="el-icon-warning"></i> {{ state[tool.action].error }}
              <el-tooltip v-if="state[tool.action].hint" :content="state[tool.action].hint" placement="top">
                <i class="el-icon-question tx-help"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonLayout>
</template>

<style scoped>
.tx-wrap {
  max-width: 1180px;
  margin: 0 auto;
  padding: 36px 28px 60px;
  animation: txFadeUp .5s ease both;
}

@keyframes txFadeUp {
  from {
    opacity: 0;
    transform: translateY(14px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tx-hero-left {
  text-align: left;
  margin-bottom: 26px;
}

.tx-hero-title {
  margin: 0 0 8px;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 4px;
  color: #e2f5ff;
}

.tx-hero-title em {
  font-style: normal;
  background: linear-gradient(90deg, #22d3ee, #818cf8, #22d3ee);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: txShine 4s linear infinite;
}

@keyframes txShine {
  to {
    background-position: 200% center;
  }
}

.tx-hero-sub {
  margin: 0;
  color: #5b7295;
  font-size: 13px;
  letter-spacing: 2px;
}

.tx-grid-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  gap: 18px;
}

.tx-card {
  position: relative;
  padding: 18px;
  border-radius: 14px;
  background: rgba(13, 20, 36, .72);
  border: 1px solid rgba(56, 189, 248, .2);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 14px 36px rgba(0, 0, 0, .4);
  transition: transform .25s, border-color .25s, box-shadow .25s;
}

.tx-card:hover {
  transform: translateY(-3px);
  border-color: rgba(34, 211, 238, .45);
  box-shadow: 0 18px 44px rgba(34, 211, 238, .12);
}

.tx-corner {
  position: absolute;
  width: 14px;
  height: 14px;
  border-color: #22d3ee;
  border-style: solid;
  border-width: 0;
  filter: drop-shadow(0 0 4px rgba(34, 211, 238, .7));
}

.tx-corner.tl {
  top: -1px;
  left: -1px;
  border-top-width: 2px;
  border-left-width: 2px;
}

.tx-corner.tr {
  top: -1px;
  right: -1px;
  border-top-width: 2px;
  border-right-width: 2px;
}

.tx-corner.bl {
  bottom: -1px;
  left: -1px;
  border-bottom-width: 2px;
  border-left-width: 2px;
}

.tx-corner.br {
  bottom: -1px;
  right: -1px;
  border-bottom-width: 2px;
  border-right-width: 2px;
}

.tx-card-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.tx-card-icon {
  font-size: 26px;
  color: #22d3ee;
  text-shadow: 0 0 14px rgba(34, 211, 238, .6);
}

.tx-card-title {
  color: #e2f5ff;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
}

.tx-card-desc {
  color: #5b7295;
  font-size: 12px;
  margin-top: 2px;
}

.tx-tool-upload {
  margin-bottom: 12px;
}

.tx-tool-upload .el-upload {
  width: 100%;
  text-align: left;
}

.tx-tool-upload .el-upload-list__item {
  background: rgba(56, 189, 248, .06);
  border: 1px solid rgba(56, 189, 248, .18);
  color: #c7d7ee;
  border-radius: 8px;
}

.tx-mini-btn {
  background: rgba(34, 211, 238, .1) !important;
  border: 1px solid rgba(34, 211, 238, .35) !important;
  color: #a5f3fc !important;
}

.tx-mini-btn:hover {
  background: rgba(34, 211, 238, .18) !important;
}

.tx-params {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.tx-param {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tx-param-label {
  color: #8fd8ee;
  font-size: 12px;
  width: 96px;
  flex-shrink: 0;
}

.tx-param-input {
  flex: 1;
}

.tx-param-input .el-input__inner,
.tx-param-input .el-input--small .el-input__inner {
  background: rgba(7, 12, 24, .6);
  border: 1px solid rgba(56, 189, 248, .3);
  color: #e2f5ff;
  border-radius: 8px;
}

.tx-run-btn {
  width: 100%;
  height: 42px;
  border: none !important;
  border-radius: 10px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #04121c !important;
  background: linear-gradient(90deg, #22d3ee, #818cf8) !important;
  box-shadow: 0 6px 18px rgba(34, 211, 238, .3);
}

.tx-run-btn:disabled {
  opacity: .45;
}

.tx-tool-result {
  margin-top: 12px;
  border-top: 1px dashed rgba(56, 189, 248, .18);
  padding-top: 10px;
}

.tx-result-ok {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #34d399;
  font-size: 13px;
}

.tx-result-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #c7d7ee;
}

.tx-dl {
  color: #34d399 !important;
  font-weight: 600;
}

.tx-del {
  color: #f87171 !important;
}

.tx-result-err {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fca5a5;
  font-size: 12.5px;
}

.tx-help {
  color: #5b7295;
  cursor: help;
}

@media (max-width: 768px) {
  .tx-wrap {
    padding: 22px 14px 48px;
  }

  .tx-grid-cards {
    grid-template-columns: 1fr;
  }
}
</style>

<script>
import CommonLayout from './common/commonPage.vue';
import { pdfTool } from '../api/tools';
import { downloadAndSave, deleteFile } from '../api/conversion';
import { normalizeError } from '../api/request';
import {
  MAX_UPLOAD_COUNT,
  checkFileSize,
  checkFileList,
} from '../utils/upload-limit';

const PDF_TOOLS = [
  { action: 'merge', title: '合并', icon: 'el-icon-connection', desc: '将多个 PDF 合并为一个', multi: true, params: [] },
  { action: 'split', title: '拆分', icon: 'el-icon-scissors', desc: '按页数拆分为多个文件', multi: false, params: [{ key: 'mode', label: '拆分方式', type: 'select', options: [{ v: 'every', t: '每页拆分' }, { v: 'range', t: '按区间' }], def: 'every' }, { key: 'step', label: '每 N 页', type: 'text', def: '1' }] },
  { action: 'extract', title: '页面提取', icon: 'el-icon-copy-document', desc: '提取指定页面', multi: false, params: [{ key: 'pages', label: '页码(如 1,3-5)', type: 'text', def: '' }] },
  { action: 'delete', title: '删除页面', icon: 'el-icon-delete', desc: '删除指定页面', multi: false, params: [{ key: 'pages', label: '页码(如 1,3-5)', type: 'text', def: '' }] },
  { action: 'reorder', title: '重排', icon: 'el-icon-sort', desc: '按新顺序重排页面', multi: false, params: [{ key: 'order', label: '新顺序(如 3,1,2)', type: 'text', def: '' }] },
  { action: 'rotate', title: '旋转', icon: 'el-icon-refresh', desc: '旋转页面', multi: false, params: [{ key: 'angle', label: '角度', type: 'select', options: [{ v: '90', t: '90°' }, { v: '180', t: '180°' }, { v: '270', t: '270°' }], def: '90' }, { key: 'pages', label: '页码(空=全部)', type: 'text', def: '' }] },
  { action: 'compress', title: '压缩', icon: 'el-icon-files', desc: '压缩 PDF 体积', multi: false, params: [{ key: 'level', label: '压缩等级', type: 'select', options: [{ v: 'screen', t: '屏幕' }, { v: 'ebook', t: '电子书' }, { v: 'printer', t: '打印' }, { v: 'prepress', t: '印刷' }], def: 'ebook' }] },
  { action: 'watermark', title: '水印', icon: 'el-icon-picture', desc: '添加文字水印', multi: false, params: [{ key: 'text', label: '水印文字', type: 'text', def: 'CONFIDENTIAL' }, { key: 'opacity', label: '透明度0-1', type: 'text', def: '0.3' }] },
  { action: 'encrypt', title: '加密', icon: 'el-icon-lock', desc: '设置打开密码', multi: false, params: [{ key: 'password', label: '密码', type: 'text', def: '' }] },
  { action: 'decrypt', title: '解密', icon: 'el-icon-unlock', desc: '去除密码(需原密码)', multi: false, params: [{ key: 'password', label: '密码', type: 'text', def: '' }] },
  { action: 'extract_images', title: '提取图片', icon: 'el-icon-picture-outline', desc: '提取 PDF 内嵌图片', multi: false, params: [] },
  { action: 'extract_text', title: '提取文字', icon: 'el-icon-document', desc: '提取 PDF 文本为 TXT', multi: false, params: [] },
];

export default {
  props: { selectedNav: { type: String, default: 'pdf' } },
  components: { CommonLayout },
  data() {
    const state = {};
    PDF_TOOLS.forEach((t) => {
      const params = {};
      t.params.forEach((p) => { params[p.key] = p.def; });
      state[t.action] = { files: [], params, loading: false, result: null, error: null, hint: null };
    });
    return { tools: PDF_TOOLS, state, maxUploadCount: MAX_UPLOAD_COUNT };
  },
  methods: {
    _extOf(name) {
      const m = String(name || '').match(/\.([A-Za-z0-9]+)$/);
      return m ? m[1].toLowerCase() : '';
    },

    // ⚠️ 本组件是 auto-upload=false，before-upload 不会触发，只能在 on-change 里校验。
    // 超限文件直接剔除并明确报错，避免用户白等整个文件传完才被后端拒。
    onFileChange(action, fileList) {
      const kept = [];
      for (const f of fileList || []) {
        if (f.status === 'fail') continue;
        const sizeErr = checkFileSize(f);
        if (sizeErr) {
          this.$message.error(sizeErr);
          continue;
        }
        kept.push(f);
      }
      if (kept.length > MAX_UPLOAD_COUNT) {
        this.$message.warning(`最多只能上传 ${MAX_UPLOAD_COUNT} 个文件，多出的已忽略`);
        kept.length = MAX_UPLOAD_COUNT;
      }
      this.state[action].files = kept;
    },
    handleExceed() {
      this.$message.warning(`最多只能上传 ${MAX_UPLOAD_COUNT} 个文件，请先移除部分文件再添加`);
    },
    runTool(tool) {
      const s = this.state[tool.action];
      if (s.files.length === 0) {
        // 原来是静默 return，用户点了没反应；改为明确提示
        this.$message.warning('请先选择要处理的 PDF 文件');
        return;
      }
      // 提交前兜底校验（与选中时同一套规则）
      const limitErr = checkFileList(s.files);
      if (limitErr) {
        this.$message.error(limitErr);
        return;
      }
      const form = new FormData();
      s.files.forEach((f) => {
        if (f.raw) form.append('file', f.raw);
      });
      // 参数
      Object.keys(s.params).forEach((k) => {
        const v = s.params[k];
        if (v !== '' && v !== null && v !== undefined) form.append(k, String(v));
      });
      s.loading = true;
      s.result = null;
      s.error = null;
      s.hint = null;
      pdfTool(tool.action, form)
        .then((resp) => {
          s.result = resp.data; // { fileName, filePath, size }
        })
        .catch((e) => {
          const info = normalizeError(e);
          s.error = info.message;
          s.hint = info.hint;
        })
        .finally(() => { s.loading = false; });
    },
    download(tool, result) {
      const base = (this.state[tool.action].files[0] && this.state[tool.action].files[0].name || 'file').replace(/\.[^.]+$/, '');
      // 优先取后端产物的真实扩展名（多产物动作为 zip，提取文字为 txt，其余 pdf）
      const extMap = { extract_text: 'txt', extract_images: 'zip', split: 'zip', merge: 'pdf' };
      const ext = this._extOf(result.fileName || result.filePath) || extMap[tool.action] || 'pdf';
      const name = `${base}_${tool.action}.${ext}`;
      this.$message.info('开始下载，大文件可能需要一些时间…');
      downloadAndSave(result.filePath, name)
        .then(() => this.$message.success('下载完成'))
        .catch(() => this.$message.error('下载失败，请确认后端在线'));
    },
    delResult(tool, result) {
      if (!result.filePath) return;
      deleteFile(result.filePath)
        .then(() => {
          this.state[tool.action].result = null;
          this.$message.success('已删除产物文件');
        })
        .catch((e) => {
          const info = normalizeError(e);
          this.$message.warning('删除失败：' + info.message);
        });
    },
  },
};
</script>
